module.exports = __webpack_public_path__ + "img/box7-3.1a810fb4.png";